import React, { useState } from 'react';
import { getVerticalOffsetForOverlay } from './getVerticalOffset';
import AnchoredModal from '@components/Shared/Modal/AnchoredModal/AnchoredModal';
import DropDownList from '@components/Shared/DropDownList/DropDownList';
import {
  allPriceChoicesMin,
  allPriceChoicesMax,
  DEFAULT_MAX_PRICE,
  DEFAULT_MIN_PRICE,
} from '@utils/homeSearchConstants';

type Props = {
  minPrice: number;
  maxPrice: number;
  onCloseClick: () => void;
  onApplyClick: (updatedPrices: { minPrice: number; maxPrice: number }) => void;
};

const FilterPrice = ({
  minPrice,
  maxPrice,
  onCloseClick,
  onApplyClick,
}: Props) => {
  const [filterMinPrice, setFilterMinPrice] = useState(minPrice);
  const [filterMaxPrice, setFilterMaxPrice] = useState(maxPrice);

  const displayfilterMinPrice = allPriceChoicesMin.find(
    (p) => p.value === filterMinPrice
  )!.text;
  const displayFilterMaxPrice = allPriceChoicesMax.find(
    (p) => p.value === filterMaxPrice
  )!.text;

  const minPriceItems = allPriceChoicesMin.filter(
    (p) => p.value < filterMaxPrice
  );
  const maxPriceItems = allPriceChoicesMax.filter(
    (p) => p.value > filterMinPrice
  );

  return (
    <AnchoredModal
      automationId="filters-price"
      applyButtonClassName="filters-price-apply-button"
      clearButtonClassName="filters-clear-button"
      onApplyButtonClick={() => {
        if (minPrice === filterMinPrice && maxPrice === filterMaxPrice) {
          onCloseClick();
        } else {
          onApplyClick({
            minPrice: filterMinPrice,
            maxPrice: filterMaxPrice,
          });
        }
      }}
      onClearButtonClick={() => {
        if (minPrice === DEFAULT_MIN_PRICE && maxPrice === DEFAULT_MAX_PRICE) {
          onCloseClick();
        } else {
          onApplyClick({
            minPrice: DEFAULT_MIN_PRICE,
            maxPrice: DEFAULT_MAX_PRICE,
          });
        }
      }}
      showOverflow={true}
      onCloseClick={onCloseClick}
      pageOverlayVerticalOffsetInPixels={getVerticalOffsetForOverlay()}
    >
      <div className="grid grid-cols-[1fr_min-content_1fr] pb-5">
        <DropDownList
          automationId="filter-min-price-click"
          id="min-price-dropdown"
          dropDownStyle="compact"
          label={displayfilterMinPrice}
          onChange={(value: { value: number }) => {
            setFilterMinPrice(value.value);
          }}
          items={minPriceItems}
          selectedValue={filterMinPrice}
          defaultValue={filterMinPrice}
          disabled={undefined}
          errorMessage={undefined}
          ariaLabel={undefined}
          onTextChange={undefined}
          selectedItem={undefined}
          selectRef={undefined}
          textBoxRef={undefined}
        >
          <></>
        </DropDownList>
        <div className="grid place-content-center px-2">-</div>
        <DropDownList
          automationId="filter-max-price-click"
          id="max-price-dropdown"
          dropDownStyle="compact"
          label={displayFilterMaxPrice}
          onChange={(value: { value: number }) => {
            setFilterMaxPrice(value.value);
          }}
          items={maxPriceItems}
          selectedValue={filterMaxPrice}
          defaultValue={filterMaxPrice}
          disabled={undefined}
          errorMessage={undefined}
          ariaLabel={undefined}
          onTextChange={undefined}
          selectedItem={undefined}
          selectRef={undefined}
          textBoxRef={undefined}
        >
          <></>
        </DropDownList>
      </div>
    </AnchoredModal>
  );
};

export default FilterPrice;
